import moment from 'moment-timezone';

export const localizeTimestamps = () => {
  document.querySelectorAll('[data-timestamp]').forEach(element => {
    const timestamp = element.getAttribute('data-timestamp');
    let format = element.getAttribute('data-timestamp-format') || 'MM/DD/YY [at] h:mma z';
    if (timestamp !== "" && timestamp !== "0") {
      const formatted = moment.tz(Number(timestamp) * 1000, moment.tz.guess()).format(format);
      element.append(formatted);
    }
  });
};

export default localizeTimestamps;